export default __webpack_public_path__ + "static/media/teachings_of_ballad.83552725.png";